<template>
    <div class="renting-page">
        <div class="logo">
            <img :src="brandLogo" alt="logo" />
        </div>
        <span class="title" v-html="replaceTranslateContent($t('m.rentingTitle'))"></span>
        <div class="duration">
            <span class="duration-title">
                {{ $t('m.rentalDuration') }}
            </span>
            <span class="duration-value">
                {{ rentalDuration }}
            </span>
        </div>
        
        <div class="fee-section">
            <div v-active-touch class="fee-header interactive-surface" @click="toggleFeeDetails">
                <span class="flex-1">{{ $t('m.currentFee') }}</span>
                <span class="fee-amount">{{ currencyFormat(rentDetail.actual_fee, rentDetail.currency) }}</span>
                <div :class="['arrow', { 'rotated': isExpanded }]"></div>
            </div>
            <div class="fee-details" :class="{ 'expanded': isExpanded }">
                <div class="fee-details-content">
                    <div class="detail-item">
                        <span>{{ $t('m.rentalNumber') }}</span>
                        <span>{{ rentDetail.rent_no || '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.rentalTime') }}</span>
                        <span>{{ rentDetail.rent_at ? time2Date(rentDetail.rent_at, 'Y-m-d H:i:s') : '-' }}</span>
                    </div>
                    <div class="detail-item">
                        <span>{{ $t('m.rentalLocation') }}</span>
                        <span>{{ rentDetail.rent_outlets || '-' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- <span class="primary-btn buy-now-btn">
            Want to keep it? Buy now!
        </span> -->

        <button v-if="mapEnabled" v-active-touch class="primary-btn nearby-return-btn" type="button" @click="goNearbyReturnMap">
            {{ $t('m.viewNearbyReturnLocations') }}
        </button>

        <div class="market-section" v-if="showMarketSection">
            <div class="market-title">
                {{ $t('m.findNearby') }}
            </div>
            <div class="app-store-container">
                <a :href="iosMarketLink" class="market-link" target="_blank">
                    <AppleStoreIcon class="market-icon" />
                </a>
                <a :href="androidMarketLink" class="market-link" target="_blank">
                    <GooglePlayIcon class="market-icon" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import {queryBorrowStatus} from "../../api/logined";
import {time2Date} from "../../utils/tool";
import { mapGetters } from 'vuex';
import AppleStoreIcon from '../../components/icons/AppleStoreIcon';
import GooglePlayIcon from '../../components/icons/GooglePlayIcon';
import { getMapRouteOrFallback } from "@/utils/mapFeature";

const CABINET_MAP_STATION_LIST_MODE_KEY = 'cabinetMapStationListModeOnce';

export default {
    name: "BorrowSuccess",
    components: {
        AppleStoreIcon,
        GooglePlayIcon
    },
    data() {
        return {
            brandName: this.$store.getters['appConfig/brand_name'],
            isExpanded: false,
            rentalDuration: "--",
            timer: null,
            rentDetail: {
                // rent_no: "HY7927389273",
                // rent_at: Math.floor(Date.now() / 1000),
                // rent_outlets: "light center",
                // currentFee: "2.00",
            },
            intervalId: null,
        }
    },
    created() {
        this.queryBorrowStatus()
        this.intervalId = setInterval(() => {
            this.queryBorrowStatus(true)
        }, 30000)
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.intervalId)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
    computed: {
        ...mapGetters('appConfig', {
            brandLogo: 'brand_logo',
            iosMarketLink: 'ios_market_link',
            androidMarketLink: 'android_market_link',
            mapEnabled: 'map_enabled',
        }),
        showMarketSection() {
            return !!this.iosMarketLink || !!this.androidMarketLink;
        },
    },
    methods: {
        time2Date: time2Date,
        queryBorrowStatus(hideLoading) {
            if (!hideLoading) {
                this.showLoading()
            }
            queryBorrowStatus().then(res => {
                // 更新仓库租借状态
                let isBorrow = parseInt(res.data.is_borrow)
                this.$store.dispatch('setIsBorrow', isBorrow)
                // 根据租借状态判断跳走还是显示成功信息
                if (isBorrow) {
                    // 更新仓库订单信息
                    this.$store.dispatch('setOrderInfo', res.data.order)
                    this.rentDetail = res.data.order;
                    this.startTimer();
                } else {
                    this.$router.push({name: 'landing_page'})
                    this.$router.push({name: 'order_info'})
                }
            }).catch(er => {
                this.toast(this.$t('eMsg.' + er.code))
            }).finally(() => {
                this.hideLoading()
            })
        },
        startTimer() {
            if (!this.rentDetail.rent_at) return;

            const updateDuration = () => {
                const now = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
                const elapsed = now - this.rentDetail.rent_at; // 计算经过的秒数

                const hours = Math.floor(elapsed / 3600);
                const minutes = Math.floor((elapsed % 3600) / 60);
                const seconds = elapsed % 60;

                this.rentalDuration = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            };

            updateDuration(); // 初始化显示
            this.timer = setInterval(updateDuration, 1000); // 每秒更新
        },
        toggleFeeDetails() {
            this.isExpanded = !this.isExpanded;
        },
        goNearbyReturnMap() {
            sessionStorage.setItem(CABINET_MAP_STATION_LIST_MODE_KEY, 'return');
            this.$router.push(getMapRouteOrFallback({
                mapEnabled: this.mapEnabled,
                isBorrow: this.$store.getters.is_borrow,
                deviceCode: this.$store.getters['appConfig/device_code'],
                machinePrecheckError: this.$store.getters['appConfig/machine_precheck_error'],
            }))
        },
        handleVisibilityChange() {
            if (document.visibilityState === 'visible') {
                this.queryBorrowStatus(true)
            }
        },
    }
};
</script>

<style lang="scss">
    .renting-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        font-family: 'SF Pro Text';

        .logo {
            height: 40px;
            width: 103px;
            margin-top: 8px;

            img {
                height: 100%;
                width: 100%;
                object-fit: contain;
                object-position: center bottom;
            }
        }

        .title {
            font-family: SF Pro Display;
            font-weight: 700;
            font-size: 20px;
            line-height: 140%;
            text-align: center;
            width: 295px;
            margin: 30px;
            color: #202124;
        }

        .duration {
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 10px;
            width: 295px;

            .duration-title {
                font-family: SF Pro Text;
                font-weight: 400;
                font-size: 16px;
                text-align: center;
                color: #9B9B9B;
            }

            .duration-value {
                font-family: Poppins;
                font-weight: 600;
                font-size: 24px;
                color: var(--theme-selectable-accent-color, #276CE1);
                font-feature-settings: "tnum"; // 确保数字等宽
            }
        }
        
        .fee-section {
            width: 329px;
            margin: 34px 0 20px;
            border-radius: 5px;
            overflow: hidden;
            
            .fee-header {
                display: flex;
                align-items: center;
                padding: 15px;
                background: #F9F9F9;
                cursor: pointer;
                position: relative;
                z-index: 1;
                color: #333333;
                font-family: SF Pro Text;
                font-weight: 600;
                font-size: 16px;

                .flex-1 {
                    flex: 1;
                }

                .fee-amount {
                    margin-right: 17px;
                }

                .arrow {
                    width: 7px;
                    height: 7px;
                    border-right: 2px solid #9B9B9B;
                    border-bottom: 2px solid #9B9B9B;
                    transform: rotate(45deg);
                    transform-origin: 60% 60%;
                    transition: transform 0.3s ease;
                    margin-bottom: 3px;
                    
                    &.rotated {
                        transform: rotate(-135deg);
                    }
                }
            }

            .fee-details {
                background: #F9F9F9;
                max-height: 0;
                overflow: hidden;
                transition: all 0.3s ease-in-out;
                position: relative;
                
                &.expanded {
                    max-height: 140px; // 需要大于等于实际高度
                }

                .fee-details-content {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 9px;
                    
                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 15px;
                        right: 15px;
                        height: 1px;
                        background: #E6E6E6;
                    }
                }

                .detail-item {
                    display: flex;
                    justify-content: space-between;
                    font-size: 12px;
                    color: #666;
                }
            }
        }

        .slide-fade-enter-active, .slide-fade-leave-active {
            transition: all 0.3s ease-in-out;
            overflow: hidden;
        }

        .buy-now-btn {
            width: 329px;
            background: #FFF;
            border: 0.5px solid #E6E6E6;
            box-shadow: 0px 1px 2.8px 0px #0000001F;
            color: #333333;
        }

        .nearby-return-btn {
            background: #FFF;
            width: 329px;
            margin-bottom: 20px;
            border: 0;
            color: #333;
        }

        .market-section {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 295px;

            .market-title {
                font-weight: 600;
                font-size: 16px;
                line-height: 111%;
                text-align: center;
                color: #333333;
            }
                
            .app-store-container {
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                .market-link {
                    width: 139px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
        }
    }
</style>
